
import env from '../env';

import {
    storageAvailable
} from '../Helpers';

/**
 * API Call method
 *
 * @param method
 * @param url
 * @param data
 * @param json
 * @param json_content
 * @constructor
 */
export const ApiCall = async (method, url, data = null, json = true, json_content = false) => {

    let auth = 'Bearer ';

    if (storageAvailable('localStorage')) {
        auth = `${auth} ${localStorage.getItem('token')}`;
    }


    let headers = {
        'Authorization': auth,
    };

    if(json_content){
        headers = {
            'Content-Type': 'application/json',
            'Authorization': auth,
        }
    }

    const rawResponse = await fetch(`${env.base_api_url}${env.api_version}${url}`, {
        method: method,
        headers: headers,
        body: data
    });

    if(json)
        return await rawResponse.json();
    else
        return await rawResponse.text();

};



// WEBPACK FOOTER //
// ./src/services/index.js